<template>
  <div>

    <div class="sidebar-box clearfix" v-if="type === 'medium'">
      <div class="left">
        <img :src="require('../assets/handshake.png')" />
      </div>
      <div class="right">
        <div v-if="!this.$props.disableInvite" style="font-size: 1.2rem; margin-bottom: .5rem;">Buyer Agents Welcome!</div>
        <p v-if="this.$props.disableInvite"></p>
        <p v-else-if="this.$props.disableLinks">
          <a>Join now</a> and <a>invite</a> your potential buyers to participate in this auction.
        </p>
        <p v-else>
          <a @click="$store.commit('openSignUpDialog')">Join now</a> and <a @click="inviteBuyer">invite</a> your potential buyers to participate in this auction.
        </p>
        <div style="font-size: 1rem; font-weight: 600; margin-bottom: .5rem;">Have questions?</div>
        <p v-if="this.$props.disableLinks">
          Visit our page to read about our service and <a>FAQ list</a>.
          We'd be happy to help you from our 24/7 help desk at {{ supportPhone }} or <a>{{ supportEmail }}</a>.
        </p>
        <p v-else>
          Visit our page to read about our service and <router-link to="/faq">FAQ list</router-link>.
          We'd be happy to help you from our 24/7 help desk at {{ supportPhone }} or <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>.
        </p>
        <div class="poweredBy" v-if="this.$props.disableLinks">
          Auction Powered by <a><img :src="require('../assets/pfx-logo-thin.png')" /></a>
        </div>
        <div class="poweredBy" v-else>
          Auction Powered by <a :href="pfxLandingPageUrl"><img :src="require('../assets/pfx-logo-thin.png')" /></a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { supportEmail, supportPhone } from '../utils/PfxUtils.js'

  export default {
    props: {
      type: {
        type: String,
        required: true
      },
      auctionId: {
        type: [ Number ],
        required: true
      },
      disableLinks: {
          type: Boolean,
          required: false,
          default: false
      },
      disableInvite: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        supportEmail,
        supportPhone,

        pfxLandingPageUrl: process.env.config.frontend.pfxLandingPage
      }
    },
    methods: {
      inviteBuyer() {
        this.$router.push(`/auction/${this.auctionId}/register/invite/buyer`)
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import 'node_modules/jeet/scss/index';

  .sidebar-box {
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .left {
    @include column(1/8);
    img { width: 100%; margin-top: 2rem; }
  }
  .right {
    @include column(7/8);
  }

  .poweredBy {
    margin-top: 1rem;
    font-size: 0.8rem;
    font-style: italic;
    img {
      width: 3.5rem;
      vertical-align: middle;
      margin-left: .5rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AuctionPoweredByWidget.vue